<div class="cardsContainer">
    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Main Info'"
            [highlight]="true"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.ContactMainInfo]"
            #mainInfoCard
        >
        </lib-generic-card>

        <lib-generic-card
            [title]="'Company Info'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.ContactCompanyInfo]"
            [hasArchivedItems]="companyHasArchived"
        >
        </lib-generic-card>
    </div>
    @if (cardsConfig[entityCardSection.ContactCustomInfo] && cardsConfig[entityCardSection.ContactCustomInfo].length) {
        <div class="cardsColumn">
            <lib-generic-card
                [title]="'Custom Info'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.ContactCustomInfo]"
                #customInfoCard
            >
            </lib-generic-card>
        </div>
    }
</div>
